import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { ExtensionGroupDetailView } from '../models/extension-group-detail-view.model';
import { GetExtensionGroupDetail_extensionGroup } from '../queries/generated/GetExtensionGroupDetail';
import * as ExtensionGroupDetailActions from './extension-group-detail.actions';

export const extensionGroupDetailFeatureKey = 'extensionGroupDetail';

export interface State {
   extensionGroup: ExtensionGroupDetailView | null;
   callState: CallState;
   queryComplete: boolean;
}

export const initialState: State = {
   callState: LoadingState.Init,
   extensionGroup: null,
   queryComplete: false,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(
      ExtensionGroupDetailActions.extensionGroupDetailLoad,
      ExtensionGroupDetailActions.extensionGroupDetailCancel,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loading,
            extensionGroup: null,
         };
      }
   ),
   on(ExtensionGroupDetailActions.loadExtensionGroupDetailSuccess, (state, action) => {
      const extensionGroup: GetExtensionGroupDetail_extensionGroup = action.data;
      return {
         ...state,
         callState: LoadingState.Loaded,
         extensionGroup: {
            ...extensionGroup,
            name: action.data.name,
            extensions: action.data.extensionGroupExtensionsConnection,
            createUser: extensionGroup.createUser as string | null,
            updateUser: extensionGroup.updateUser as string | null,
         },
      };
   }),
   on(ExtensionGroupDetailActions.loadExtensionGroupDetailFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(ExtensionGroupDetailActions.saveExtensionGroupDetail, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(
      ExtensionGroupDetailActions.saveExtensionGroupDetailFailure,
      ExtensionGroupDetailActions.extensionGroupDetailAccessDenied,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   )
);
